import { kp } from "../karkhanaPaths";

/** The supervisor sign-in link and the message the studio sends them (WhatsApp / SMS / copy). */
export const supervisorLoginUrl = (origin: string, studio?: string): string =>
  `${origin.replace(/\/+$/, "")}${kp.login({ studio })}`;

/** "98390 12345" / "+91 98390-12345" → "919839012345" for wa.me; null when it isn't a phone number. */
export const waNumber = (phone: string): string | null => {
  const d = (phone || "").replace(/\D/g, "");
  if (d.length === 10) return `91${d}`;
  if (d.length === 12 && d.startsWith("91")) return d;
  return d.length >= 11 && d.length <= 15 ? d : null;
};

/** Bilingual message: what to open, which number, which PIN. PIN only when given (it isn't stored readable). */
export const loginMessage = (o: { name: string; studio?: string; url: string; phone: string; pin?: string }): string =>
  [
    `${o.studio ? `${o.studio} · ` : ""}HKP Karkhana`,
    `${o.name}, your supervisor login / आपका सुपरवाइज़र लॉगिन:`,
    o.url,
    `Mobile / मोबाइल: ${o.phone}`,
    o.pin ? `PIN / पिन: ${o.pin}` : "PIN: ask the studio / पिन स्टूडियो से लें",
    "Open the link on your phone, enter the mobile number and PIN once. You stay signed in. / फ़ोन पर लिंक खोलें, एक बार मोबाइल नंबर और पिन डालें। आप लॉगिन रहेंगे।",
    "Add it to your home screen to open it like an app. / इसे होम स्क्रीन पर जोड़ें, ऐप की तरह खुलेगा।",
  ].join("\n");

/** A 6-digit PIN that isn't one digit repeated or a plain run (the server refuses those too). */
export const makePin = (rand: () => number = () => (globalThis.crypto || (window as any).crypto).getRandomValues(new Uint32Array(1))[0]): string => {
  const easy = ["123456", "654321", "012345", "543210", "123123", "121212"];
  for (;;) {
    const pin = String(rand() % 1000000).padStart(6, "0");
    if (new Set(pin).size > 1 && !easy.includes(pin)) return pin;
  }
};

export const whatsappHref = (phone: string, text: string): string => {
  const n = waNumber(phone);
  return `https://wa.me/${n || ""}?text=${encodeURIComponent(text)}`;
};

export const smsHref = (phone: string, text: string): string => `sms:${(phone || "").replace(/[^\d+]/g, "")}?&body=${encodeURIComponent(text)}`;
